import ReactDOM from "react-dom";
import "./styles/index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import TimeAgo from "javascript-time-ago";
import enSG from "javascript-time-ago/locale/en-SG.json";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

TimeAgo.addDefaultLocale(enSG);

if (process.env.NODE_ENV && process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://de93a388036d4564a7bbabe187f7f6df@o438870.ingest.sentry.io/6612890",
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.1,
  });
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
